export const SET_UNREAD_MSG = '[CONV] SET_UNREAD_MSG'
export const SET_IS_IN_CONV_ROOM = '[CONV] SET_IS_IN_CONV_ROOM'

export const LIST_CLEAR_DATA = '[CONV] LIST_CLEAR_DATA'

export const LIST_REFETCH = '[CONV] LIST_REFETCH'

export const LIST_FETCH_INIT = '[CONV] LIST_FETCH_INIT'
export const LIST_FETCH_SUCCESS = '[CONV] LIST_FETCH_SUCCESS'
export const LIST_FETCH_FAILURE = '[CONV] LIST_FETCH_FAILURE'
export const LIST_FETCH_EMPTY = '[CONV] LIST_FETCH_EMPTY'
export const LIST_FETCH_FINAL = '[CONV] LIST_FETCH_FINAL'
export const LIST_FETCH_MORE = '[CONV] LIST_FETCH_MORE'
export const UPDATE_CONVERSATION_LIST = '[CONV] UPDATE_CONVERSATION_LIST'
export const UPDATE_HISTORY_ID = '[CONV] UPDATE_HISTORY_ID'
export const UPDATE_BADGE = '[CONV] UPDATE_BADGE'

export function clearConversationList() {
  return {
    type: LIST_CLEAR_DATA,
  }
}

export function setUnreadMessage(hasUnreadMessage) {
  return {
    type: SET_UNREAD_MSG,
    payload: { hasUnreadMessage: hasUnreadMessage },
  }
}

export function setIsInConversationRoom(isInConversationRoom) {
  return {
    type: SET_IS_IN_CONV_ROOM,
    payload: { isInConversationRoom: isInConversationRoom },
  }
}

export const updateConversationList = (data) => {
  return {
    type: UPDATE_CONVERSATION_LIST,
    payload: data,
  }
}

export const updateBadgeConversationList = (data) => {
  return {
    type: UPDATE_BADGE,
    payload: data,
  }
}

export const refetchConversation = (data = {}) => {
  return {
    type: LIST_REFETCH,
    payload: data,
  }
}

export const onFetchEmpty = () => {
  return {
    type: LIST_FETCH_EMPTY,
  }
}

export const onFetchFinal = (data, key) => {
  return {
    type: LIST_FETCH_FINAL,
    payload: data,
    key: key,
  }
}

export const onFetchSuccess = (data, key) => {
  return {
    type: LIST_FETCH_SUCCESS,
    payload: data,
    key: key,
  }
}

export const onFetchFailure = (error) => {
  return {
    type: LIST_FETCH_FAILURE,
    payload: error,
  }
}

export const updateHistoryId = (historyId) => {
  return {
    type: UPDATE_HISTORY_ID,
    payload: historyId,
  }
}

export const onFetchInit = () => {
  return {
    type: LIST_FETCH_INIT,
  }
}

export const onFetchMore = () => {
  return {
    type: LIST_FETCH_MORE,
  }
}
